<div class="treeslo-grid-root">
    @if (responsiveCardsActive) {
    <!-- Mobile: cards layout with paginator on top -->
    @if (hasPaginator) {
    <div class="treeslo-grid-paginator treeslo-grid-paginator--top">
        <app-treeslo-paginator-cursor-based [pageSizeOptions]="paginatorPageSizeOptions"
            [paginatorConfig]="paginatorInitialConfig" [pageSizeDisabled]="!tableData.length"
            (pageChange)="onPaginatorPageChange($event)">
        </app-treeslo-paginator-cursor-based>
    </div>
    }
    @if (tableData.length === 0) {
    <div class="empty-state alternative-view">
        <div class="alternative-view-image">
            <img [src]="noDataImageSrc" alt="{{ 'common.noDataAlt' | translate }}" />
        </div>
        <div class="alternative-view-content">
            <h3>{{ 'common.noDataTitle' | translate }}</h3>
            <p>{{ 'common.noDataDescription' | translate }}</p>
        </div>
    </div>
    } @else {
    <div class="treeslo-grid-cards">
        @for (row of tableData; track getRowTrackId(row, $index); let rowIndex = $index) {
        <div class="treeslo-grid-card" (click)="onRowClick(rowIndex, $event)"
            [class.selected-row]="isRowSelected(rowIndex)" [class.active-row]="activeRowIndex === rowIndex">
            <div class="treeslo-grid-card-main"
                [class.treeslo-grid-card-main--projected]="hasResponsiveCardTemplate">
                @if (config.multirowSelection) {
                <div class="treeslo-grid-card-select">
                    <mat-checkbox [checked]="isRowSelected(rowIndex)" (click)="$event.stopPropagation()"
                        (change)="toggleRowSelection(rowIndex, true)" aria-label="Select row"></mat-checkbox>
                </div>
                }
                <div class="treeslo-grid-card-body">
                    @if (hasResponsiveCardTemplate) {
                    <ng-container
                        *ngTemplateOutlet="responsiveCardTemplate!.templateRef; context: { $implicit: row, row: row, rowIndex: rowIndex }"></ng-container>
                    } @else {
                    @for (column of defaultCardColumns; track getColumnTrackId(column)) {
                    <div class="treeslo-grid-card-field">
                        <span class="treeslo-grid-card-label">{{ getTranslationKey(getHeaderValue(column)) | translate
                            }}</span>
                        <span class="treeslo-grid-card-value">
                            @if (isColumnPopoverActive(column, row)) {
                            <app-popover #cellPopover class="treeslo-grid-cell-popover"
                                [trigger]="getColumnPopoverTrigger(column)"
                                [positions]="column.popover?.positions ?? defaultPopoverPositions"
                                [content]="getColumnPopoverContent(column, row)"
                                [bodyComponent]="column.popover!.bodyComponent"
                                [bodyInputs]="getColumnPopoverBodyInputs(column, row, cellPopover)"
                                [panelClass]="column.popover!.panelClass ?? ''">
                                <span class="treeslo-grid-popover-trigger">
                                    <ng-container
                                        *ngTemplateOutlet="gridCellInner; context: { row: row, column: column, rowIndex: rowIndex }" />
                                </span>
                            </app-popover>
                            } @else {
                            <ng-container
                                *ngTemplateOutlet="gridCellInner; context: { row: row, column: column, rowIndex: rowIndex }" />
                            }
                        </span>
                    </div>
                    }
                    }
                </div>
                @if (hasActionsOrDetails()) {
                <div class="treeslo-grid-card-actions actions-column">
                    <ng-container
                        *ngTemplateOutlet="gridRowActions; context: { row: row, rowIndex: rowIndex, stopRowClick: true }"></ng-container>
                </div>
                }
            </div>
            @if (config.rowDetails && rowDetailsTemplate?.templateRef && isRowExpanded(rowIndex)) {
            <div class="treeslo-grid-card-details">
                <ng-container
                    *ngTemplateOutlet="rowDetailsTemplate!.templateRef; context: { $implicit: row, row: row, rowIndex: rowIndex }">
                </ng-container>
            </div>
            }
        </div>
        }
    </div>
    }
    } @else {
    <div class="treeslo-grid-table-wrapper">
        <table class="treeslo-grid-table" [class.striped-grid]="config.striped">
            <thead>
                <tr cdkDropList cdkDropListOrientation="horizontal"
                    [cdkDropListDisabled]="!isColumnReorderActive"
                    (cdkDropListDropped)="onColumnDrop($event)">
                    @if (config.multirowSelection) {
                    <th class="row-selection-header">
                        <mat-checkbox [checked]="isAllSelected()" [indeterminate]="isSomeSelected()"
                            (change)="toggleAllRows($any($event).checked)" aria-label="Select all rows"></mat-checkbox>
                    </th>
                    }
                    @for (column of displayColumns; track getColumnTrackId(column)) {
                    <th [attr.data-column-field]="column.fieldName"
                        [ngClass]="getColumnAlignmentClass(column)"
                        [class.treeslo-grid-header--sortable]="isColumnSortControlVisible(column)"
                        cdkDrag
                        cdkDragLockAxis="x"
                        [cdkDragDisabled]="!isColumnDraggable(column)">
                        <div class="treeslo-grid-header-cell"
                            [class.treeslo-grid-header-cell--right]="column.align === 'right'"
                            [class.treeslo-grid-header-cell--center]="column.align === 'center'">
                            @if (isColumnDraggable(column)) {
                            <button type="button" class="treeslo-grid-column-drag-handle"
                                cdkDragHandle
                                [attr.aria-label]="'common.reorderColumn' | translate">
                                <i-tabler name="grip-vertical" class="treeslo-grid-column-drag-handle-icon"></i-tabler>
                            </button>
                            }
                            <span class="treeslo-grid-header-label"
                                [matTooltip]="getHeaderLabelTooltip(column) ?? ''"
                                [matTooltipDisabled]="!getHeaderLabelTooltip(column)">
                                {{ getHeaderLabel(column) }}
                            </span>
                            @if (isColumnSortControlVisible(column)) {
                            <button type="button" class="treeslo-grid-sort-button"
                                (click)="onSortHeaderClick(column, $event)"
                                [attr.aria-label]="getColumnSortAriaLabel(column)">
                                <i-tabler [name]="getColumnSortIcon(column)" class="treeslo-grid-sort-icon"></i-tabler>
                                @if (getColumnSortPriority(column); as priority) {
                                <span class="treeslo-grid-sort-priority">{{ priority }}</span>
                                }
                            </button>
                            }
                        </div>
                    </th>
                    }
                    @if (hasActionsOrDetails()) {
                    <th class="actions-header"></th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (row of tableData; track getRowTrackId(row, $index); let rowIndex = $index) {
                <tr (click)="onRowClick(rowIndex, $event)" [class.selected-row]="isRowSelected(rowIndex)"
                    [class.active-row]="activeRowIndex === rowIndex">
                    @if (config.multirowSelection) {
                    <td class="row-selection-column">
                        <mat-checkbox [checked]="isRowSelected(rowIndex)" (click)="$event.stopPropagation()"
                            (change)="toggleRowSelection(rowIndex, true)" aria-label="Select row"></mat-checkbox>
                    </td>
                    }
                    @for (column of displayColumns; track getColumnTrackId(column)) {
                    <td>
                        <div class="cell-content"
                            [ngClass]="[getColumnAlignmentClass(column), getWidgetComponent(column, row) ? 'widget-cell' : '']">
                            @if (isColumnPopoverActive(column, row)) {
                            <app-popover #cellPopover class="treeslo-grid-cell-popover"
                                [trigger]="getColumnPopoverTrigger(column)"
                                [positions]="column.popover?.positions ?? defaultPopoverPositions"
                                [content]="getColumnPopoverContent(column, row)"
                                [bodyComponent]="column.popover!.bodyComponent"
                                [bodyInputs]="getColumnPopoverBodyInputs(column, row, cellPopover)"
                                [panelClass]="column.popover!.panelClass ?? ''">
                                <span class="treeslo-grid-popover-trigger">
                                    <ng-container
                                        *ngTemplateOutlet="gridCellInner; context: { row: row, column: column, rowIndex: rowIndex }" />
                                </span>
                            </app-popover>
                            } @else {
                            <ng-container
                                *ngTemplateOutlet="gridCellInner; context: { row: row, column: column, rowIndex: rowIndex }" />
                            }
                        </div>
                    </td>
                    }
                    @if (hasActionsOrDetails()) {
                    <td>
                        <div class="actions-column">
                            <ng-container
                                *ngTemplateOutlet="gridRowActions; context: { row: row, rowIndex: rowIndex, stopRowClick: false }"></ng-container>
                        </div>
                    </td>
                    }
                </tr>
                @if (config.rowDetails && rowDetailsTemplate?.templateRef && isRowExpanded(rowIndex)) {
                <tr class="row-details-row">
                    <td style="border-bottom: solid 2px var(--mat-sys-primary);"
                        [attr.colspan]="displayColumns.length + (config.multirowSelection ? 1 : 0) + (hasActionsOrDetails() ? 1 : 0)">
                        <div class="row-details-cell">
                            <ng-container
                                *ngTemplateOutlet="rowDetailsTemplate!.templateRef; context: { $implicit: row, row: row, rowIndex: rowIndex }">
                            </ng-container>
                        </div>
                    </td>
                </tr>
                }
                }
            </tbody>
        </table>
        @if (tableData.length === 0) {
        <div class="empty-state alternative-view">
            <div class="alternative-view-image">
                <img [src]="noDataImageSrc" alt="{{ 'common.noDataAlt' | translate }}" />
            </div>
            <div class="alternative-view-content">
                <h3>{{ 'common.noDataTitle' | translate }}</h3>
                <p>{{ 'common.noDataDescription' | translate }}</p>
            </div>
        </div>
        }
    </div>
    @if (hasPaginator) {
    <div class="treeslo-grid-paginator">
        <app-treeslo-paginator-cursor-based [pageSizeOptions]="paginatorPageSizeOptions"
            [paginatorConfig]="paginatorInitialConfig" [pageSizeDisabled]="!tableData.length"
            (pageChange)="onPaginatorPageChange($event)">
        </app-treeslo-paginator-cursor-based>
    </div>
    }
    }
</div>

<ng-template #gridCellInner let-row="row" let-column="column" let-rowIndex="rowIndex">
    @if (getColumnTemplate(column)) {
    <ng-container
        *ngTemplateOutlet="getColumnTemplate(column)!; context: { $implicit: row, row: row, column: column, rowIndex: rowIndex }"></ng-container>
    } @else if (getWidgetComponent(column, row)) {
    <ng-container
        *ngComponentOutlet="getWidgetComponent(column, row)!; inputs: getWidgetInputs(row, column)"></ng-container>
    } @else {
    @if (column.pipes && column.pipes.length) {
    @if (!isEmptyValue(row, column)) {
    {{ getCellValue(row, column) | dynamicPipe: column.pipes : localeKey }}
    } @else {
    ---
    }
    } @else {
    {{ formatCellValue(row, column) }}
    }
    }
</ng-template>

<ng-template #gridRowActions let-row="row" let-rowIndex="rowIndex" let-stopRowClick="stopRowClick">
    @if (shouldCollapseRowActions(row)) {
    @let overflowAction = getMobileOverflowDropdownAction(row);
    @if (isDropdownActionVisible(overflowAction, row)) {
    <app-treeslo-grid-action-menu
        #overflowActionMenu
        [actions]="getVisibleDropdownActions(overflowAction.dropdownChildrenActions ?? [], row)"
        [row]="row"
        [rowIndex]="rowIndex"
        [host]="actionMenuHost" />
    <button class="action-button" type="button" [matMenuTriggerFor]="overflowActionMenu.menu"
        #overflowMenuTrigger="matMenuTrigger"
        (click)="onRowActionMenuClick($event, stopRowClick)"
        (menuOpened)="onDropdownMenuOpened(overflowMenuTrigger)"
        (menuClosed)="onDropdownMenuClosed()"
        [disabled]="isDropdownActionDisabled(overflowAction, row)"
        [matTooltip]="'common.actions' | translate"
        [attr.aria-label]="'common.actions' | translate">
        <i-tabler name="dots-vertical" class="action-icon"></i-tabler>
    </button>
    }
    } @else {
    @for (action of config.actionsGridRows; track getActionTrackId($index, action)) {
    @if (action.dropdownMode) {
    @if (isDropdownActionVisible(action, row)) {
    <app-treeslo-grid-action-menu
        #rowActionMenu
        [actions]="getVisibleDropdownActions(action.dropdownChildrenActions ?? [], row)"
        [row]="row"
        [rowIndex]="rowIndex"
        [host]="actionMenuHost" />
    <button class="action-button" type="button" [matMenuTriggerFor]="rowActionMenu.menu"
        #rowDropdownMenuTrigger="matMenuTrigger"
        (click)="onRowActionMenuClick($event, stopRowClick)"
        (menuOpened)="onDropdownMenuOpened(rowDropdownMenuTrigger)"
        (menuClosed)="onDropdownMenuClosed()"
        [disabled]="isDropdownActionDisabled(action, row)"
        [matTooltip]="getActionTooltip(action, row) | translate"
        [matTooltipDisabled]="!getActionTooltip(action, row)">
        @if (action.icon) {
        <i-tabler [name]="action.icon" class="action-icon"></i-tabler>
        }
        @if (action.label) {
        <span>{{ getActionDisplayValue(action) | translate }}</span>
        }
    </button>
    }
    } @else {
    @if (isActionVisible(action, row)) {
    <button class="action-button" type="button"
        (click)="executeAction(action, row, $event, rowIndex)"
        [disabled]="isActionDisabled(action, row)"
        [matTooltip]="getActionTooltip(action, row) | translate"
        [matTooltipDisabled]="!getActionTooltip(action, row)">
        @if (action.icon) {
        <i-tabler [name]="action.icon" class="action-icon"></i-tabler>
        }
        @if (action.label) {
        <span>{{ getActionDisplayValue(action) | translate }}</span>
        }
    </button>
    }
    }
    }
    }
    @if (config.rowDetails && rowDetailsTemplate?.templateRef) {
    <button class="expand-button" type="button"
        (click)="activeRowIndex = rowIndex; toggleRowDetails(rowIndex); $event.stopPropagation()"
        [attr.aria-expanded]="isRowExpanded(rowIndex)" aria-label="Toggle row details">
        <i-tabler [name]="isRowExpanded(rowIndex) ? 'chevron-up' : 'chevron-down'" class="action-icon"></i-tabler>
    </button>
    }
</ng-template>
